// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__rDhPU","range":"MonthRangeSwitch_range__1IgOu","disabled":"MonthRangeSwitch_disabled__27zFa"};